import classNames from 'classnames';
import React from 'react';
import { createUseStyles } from 'react-jss';
import _ from 'lodash';
import { useAnalytics } from '../../utils/setup/analytics-setup';
import { layoutDefaults } from '../../utils/layout-defaults';
import { Hint } from '../hint';

function Options({ className, values, visible }) {
  const { analyticsHollowEvent } = useAnalytics();
  const classes = useStyles();

  function onPress() {
    analyticsHollowEvent('group options click');
  }

  return (
    <>
      {' '}
      {!_.isEmpty(values) && visible && (
        <div
          className={classNames(className, classes.container)}
          onClick={onPress}
          aria-hidden
        >
          {values.map((option) => (
            <span key={option.id} className={classes.option}>
              <span className={classes.marker}>◦</span>
              <span className={classes.text}>
                <span>{option.name}</span>
                <Hint
                  className={classes.hint}
                  value={option.hint}
                  showParenthesis
                />
              </span>
            </span>
          ))}
        </div>
      )}
    </>
  );
}

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    // fontSize: layoutDefaults.smallFontSize,
    // fontWeight: 'light',
    opacity: layoutDefaults.opacity,
    marginTop: layoutDefaults.verticalMargin,
    // border: '1px solid blue',
  },
  option: {
    // display: 'inline-block',
    // whiteSpace: 'nowrap',
    // color: 'red',
    // marginLeft: layoutDefaults.smallerHorizontalMargin,
    // marginRight: layoutDefaults.smallerHorizontalMargin,
    // border: '1px solid red',
  },
  marker: {
    // marginRight: layoutDefaults.smallerHorizontalMargin,
  },
  text: {
    // fontWeight: 'bolder',
    marginLeft: layoutDefaults.smallerHorizontalMargin,
    marginRight: layoutDefaults.smallerHorizontalMargin,
  },
  hint: {
    marginLeft: layoutDefaults.smallerHorizontalMargin,
    // marginRight: layoutDefaults.smallerHorizontalMargin,
  },
});

export { Options };
